import '@/css/app.css'
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import './cookie-consent-mode.js'
import './base/revealOnScroll.js'
import './base/parallax.js'

import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

import Lenis from 'lenis'
const lenis = new Lenis({
    autoRaf: true,
    anchors: {
        offset: 0
    },
    prevent: (node) => {
        const classes = ['pm-wrapper']
        return classes.some((cls) => node.classList.contains(cls))
    }
})

window.lenis = lenis

// App main
const main = async () => {
    // Dit komt overeen met de twig var blockHandle
    // const blocks = []
    const components = [
        'fancybox',
        'swiper',
        'accordionComp',
        'accordion',
        'langSwitcher',
        'googleMaps',
        'faq',
        'count',
        'plyr'
    ]

    const importPromises = []

    // for (const block of blocks) {
    //     const blockElements = document.querySelectorAll(`.${block}`)

    //     if (blockElements.length === 0) {
    //         continue
    //     }

    //     const importPromise = import(`./blocks/${block}.js`).then(
    //         ({ init }) => {
    //             blockElements.forEach((block) => {
    //                 importPromises.push(init(block))
    //             })
    //         }
    //     )

    //     importPromises.push(importPromise)
    // }

    for (const comp of components) {
        const compElements = document.querySelectorAll(`.${comp}`)
        if (compElements.length === 0) {
            continue
        }

        const importPromise = import(`./components/${comp}.js`).then(
            ({ init }) => {
                compElements.forEach((comp) => {
                    importPromises.push(init(comp, lenis))
                })
            }
        )

        importPromises.push(importPromise)
    }

    importPromises.push(
        import('./base/animations.js').then(({ initAnimations }) =>
            initAnimations()
        )
    )

    importPromises.push(
        import('./base/menu.js').then(({ initMenu }) => initMenu())
    )

    importPromises.push(
        import('./base/logoWallCycle.js').then(({ initLogoWallCycle }) =>
            initLogoWallCycle()
        )
    )

    importPromises.push(
        import('./base/locationsList.js').then(({ initLocationsList }) =>
            initLocationsList()
        )
    )

    importPromises.push(
        import('./base/locationsView.js').then(({ initLocationsView }) =>
            initLocationsView()
        )
    )

    importPromises.push(
        import('./base/locationsMap.js').then(({ initLocationsMap }) =>
            initLocationsMap()
        )
    )

    importPromises.push(
        import('./base/locationsModal.js').then(({ initLocationsModal }) =>
            initLocationsModal()
        )
    )

    importPromises.push(
        import('./base/homeIntro.js').then(({ initHomeIntro }) =>
            initHomeIntro()
        )
    )

    importPromises.push(
        import('./base/homeBannerScroll.js').then(({ initHomeBannerScroll }) =>
            initHomeBannerScroll()
        )
    )

    importPromises.push(
        import('./base/interactiveBlock.js').then(({ initInteractiveBlock }) =>
            initInteractiveBlock()
        )
    )

    importPromises.push(
        import('./base/interactiveScrollBlock.js').then(
            ({ initInteractiveScrollBlock }) => initInteractiveScrollBlock()
        )
    )

    importPromises.push(
        import('./base/soundToggle.js').then(({ initSoundToggle }) =>
            initSoundToggle()
        )
    )

    importPromises.push(
        import('./base/audioButton.js').then(({ initAudioButtons }) =>
            initAudioButtons()
        )
    )

    importPromises.push(
        import('./base/formReveal.js').then(({ initFormReveal }) =>
            initFormReveal()
        )
    )

    importPromises.push(
        import('./base/scrambleText.js').then(({ initScrambleText }) =>
            initScrambleText()
        )
    )

    importPromises.push(
        import('./base/magnetic.js').then(({ initMagnetic }) => initMagnetic())
    )

    importPromises.push(
        import('./base/textReveal.js').then(({ initTextReveal }) =>
            initTextReveal()
        )
    )

    importPromises.push(
        import('./base/footerLogo.js').then(({ initFooterLogo }) =>
            initFooterLogo()
        )
    )
    return await Promise.all(importPromises)
}

main().then(() => {
    console.log('Vite <3')
    window.Alpine = Alpine

    Alpine.plugin(collapse)
    Alpine.start()

    // Once every module is listening: a link to a location in the locations block (#map-2, #list-2)
    import('./base/locationsLink.js').then(({ initLocationsLink }) =>
        initLocationsLink()
    )

    const anchor = getAnchor()
    if (anchor) {
        const anchorElement = document.querySelector(`#${anchor}`)
        if (anchorElement) {
            setTimeout(() => {
                lenis.scrollTo(anchorElement, {
                    offset: -50
                })
            }, 500)
        }
    }

    setTimeout(() => {
        ScrollTrigger.refresh()
        window.dispatchEvent(new Event('resize'))
    }, 1000)
})

const getAnchor = () => {
    var currentUrl = document.URL,
        urlParts = currentUrl.split('#')

    return urlParts.length > 1 ? urlParts[1] : null
}

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}
